<template lang="pug">
v-card(max-width="300px", width="100%", flat)
  v-img.elevation-4.ebook-card-img(
    :src="img + '?resize=1&w=300'",
    :aspect-ratio="521 / 768",
    :alt="title"
  )
    v-card.ebook-card-button.justify-center.align-center(
      height="100%",
      width="100%",
      color="#00000055",
      :href="file || link",
      target="_blank"
    )
      .d-flex.flex-column.justify-center.align-center
        v-btn(color="primary", fab)
          v-icon fas fa-eye
        v-chip.mt-4 Visualizar
  v-card-title.text-body-2.black--text.font-weight-bold.text-uppercase.ebook-card-title.d-flex.justify-center.text-center.pb-0 {{ titleParts[0] }}
  v-card-subtitle.text-center.text-body-2.mt-0(v-if="titleParts[1]") {{ titleParts[1] }}
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    file: {
      type: String,
    },
    link: {
      type: String,
    },
  },
  computed: {
    titleParts() {
      return this.title.replace(/ ?\| ?/, "|").split("|");
    },
  },
};
</script>

<style>
.ebook-card-button {
  display: none;
  height: 100%;
  width: 100%;
}
.ebook-card-img:hover .ebook-card-button {
  display: flex;
}
.ebook-card-title {
  line-height: 20px !important;
}
</style>
